import { render, staticRenderFns } from "./handleScrap.vue?vue&type=template&id=237ef366&scoped=true"
import script from "./handleScrap.vue?vue&type=script&lang=js"
export * from "./handleScrap.vue?vue&type=script&lang=js"
import style0 from "./handleScrap.vue?vue&type=style&index=0&id=237ef366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ef366",
  null
  
)

export default component.exports